import { RmsAccountOccupationSelect } from '@/ui/features/badging/badging-customizations/badge-create/RmsAccountOccupationSelect';
import { AccountBadgeOptionsSelectProps } from '@juvare/badging/ui/@types/AccountBadgeOptionsSelectProps';
import { ManageBadgesPanelProps } from '@juvare/badging/ui/features/badge-management/ManageBadgesPanel';
import { AccountSelection } from '@juvare/badging/ui/features/badge-management/components/BadgeAccountsSelectionPanel/types';
import { ComponentType } from 'react';

export const extendAccountSelectionOptionComponents: NonNullable<ManageBadgesPanelProps['extendAccountSelectionOptionComponents']> = (
    components,
) => [...components, RmsAccountOccupationSelect as ComponentType<AccountBadgeOptionsSelectProps<AccountSelection>>];
